// extracted by mini-css-extract-plugin
export default {"footer":"RelativeInfoSidePage-module--footer--GmM7s","footerLeft":"RelativeInfoSidePage-module--footerLeft--oUyUq"};